<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3">
            <div class="custom-header font-weight-bold text-left">Mailing Resource</div>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm tnkc-success" type="button" data-toggle="modal" data-target="#mailResource" v-on:click="setAddResource">
              <font-awesome-icon icon="mail-bulk"/>
              ADD
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-body">
              <div class="table-responsive-sm fa-1x" style="height: 400px !important;  overflow: auto;">
                <table class="table table-bordered sticky-header" width="100%" cellspacing="0">
                  <thead>
                    <tr class="bg-light small">
                      <th scope="col" class="p-1 text-center" width="15px">#</th>
                      <th scope="col" class="p-1">NAME OF USER</th>
                      <th scope="col" class="p-1">EMAIL</th>
                      <th scope="col" class="p-1">STATUS</th>
                      <th scope="col" class="p-1">ACTION</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(mailresource,index) in mailingResources" :key="mailresource.emailResourceId">
                      <th scope="col">{{index + 1}}</th>
                      <td class="p-1 align-middle text-left pl-2">{{titleCase(mailresource.userName)}}</td>
                      <td class="p-1 pl-2 align-middle text-left small">
                        <span>{{mailresource.userEmail}}</span>
                      </td>
                      <td class="p-1 align-middle  text-center small">{{mailresource.emailResourceStatus}}</td>
                      <td class="p-1 vert-aligned">
                        <button class="btn btn-xsm btn-danger ml-1" v-on:click="delete_mail_resource(mailresource.emailResourceId)">
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="mailResource" tabindex="-1" role="dialog" aria-labelledby="mailResourceTitle" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="mailResourceTitle">Add Mail Resource</h5>
          </div>
          <div class="modal-body">

            <div class="col-md-6 pr-0">
              <input type="text"
                     class="form-control search-input"
                     aria-label="Default"
                     placeholder="Search User" autofocus
                     v-model="formParams.searchValue"
                     v-focus
                    v-on:input="searchMailResource">
            </div>

            <div class="mt-2" style="height: 300px !important;  overflow: auto;">
              <div class="table-responsive-sm fa-1x border-top">
                <table class="table table-bordered sticky-header">
                  <thead>
                    <tr class="bg-light small">
                      <th scope="col" class="p-1 text-center" width="10">#</th>
                      <th scope="col" class="p-1">User Name</th>
                      <th scope="col" class="p-1">Email</th>
                      <th scope="col" class="p-1">Select</th>
                    </tr>
                  </thead>

                  <tbody class="mt-1">
                    <tr v-for="(userMailResource,index) in usersMailingResource" :key="usersMailingResource.userId">
                    <td class="p-1 text-center" width="10">{{index + 1}}</td>
                    <td class="p-1 text-left">
                      <span class="ml-1">{{titleCase(userMailResource.userName)}}</span>
                    </td>
                    <td class="p-1">
                      <span class="ml-1">
                        {{userMailResource.userEmail}}
                      </span>
                    </td>
                    <td class="p-1 align-middle">
                      <div>
                        <input type="checkbox" id="mailingResource" v-model="newMailingResource.userIds" :value="userMailResource.userId">
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn tnkc-secondary" data-dismiss="modal" v-on:click="setAddResource">Close</button>
            <button type="button" class="btn tnkc-primary" v-on:click="create_new_mail_resource">Save changes</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {appMixins} from '@/mixins/app.mixins';
import {formMixins} from '@/mixins/formMixins';

export default {
  name: 'MailingResource',
  mixins:[appMixins,formMixins],
  data(){
    return {
      //todo addd variables for the checking here.
      formParams : {
        searchValue : null
      },
      addResource : false,
    }
  },
  methods : {
    ...mapActions([
        'getMailingResources',
        'getUsersNotInMailing',
        'getMailResource',
        'createNewMailResource',
        'setNullMailResources',
        'setNullMailResrouce',
        'setNullUsersForMailingResource',
        'deleteMailResource'
    ]),

    async searchMailResource(){
      await this.getUsersNotInMailing(this.formParams);
    },

    setAddResource(){
      this.addResource = !this.addResource;
    },

    async create_new_mail_resource(){
      if( await this.questionAlert('Are you sure you want to add this into cc- mailing resource.?','Add Email CC')){
        this.createNewMailResource(this.newMailingResource).then((r)=>{
          if(r == true){
            this.successAlert('Adding Email to CC successfully');
            this.searchMailResource();
            this.getMailingResources();
            $('#mailResource').modal('hide');
          }
        });
      }
    },

    async delete_mail_resource(obj = null){
      if(await this.questionAlert('Are you sure you want to delete user from email resource?')){
        this.deleteMailResource(obj).then((r)=>{
          if(r == true){
            this.successAlert('Delete Resource Email Successfully');
          }
        })
      }
    }
  },

  computed : {
    ...mapGetters([
        'usersMailingResource',
        'mailingResource',
        'mailingResources',
        'newMailingResource'
    ])
  },

  mounted() {
    console.log('component for the mailing pass.')
  },

 async created() {
    this.getMailingResources();
  },

  watch : {
    addResource : function(val){
      if(val == true){
        this.searchMailResource();
      }else {
        this.setNullUsersForMailingResource();
      }
    }
  },

  destroyed() {
    //
  },

};
</script>

<style scoped>
  .sticky-header > thead > tr > th {
    background-color: #dee2e6 !important;
    position: sticky !important;
    z-index: 100;
    top: 0;
  }

  input[type=checkbox] {
    transform: scale(1.6);
  }
</style>
